<script lang="ts" setup>
import { PlanktonSearchResultSortOrder } from "~~/server/plankton";
import { slugifier } from "~~/shared/utils/slugifier";

defineProps<{ size: "md" | "lg" }>();

function slugged(str?: string) {
  return slugifier(str ?? "");
}

const { t } = useI18n();
const { loggedIn } = useUserSession();

const { searchState } = useCatalog({
  initialize: {
    searchState: false,
    catalog: false,
    ssr: !loggedIn.value,
    scrollIntoViewThreshold: 500,
  },
});

const options = searchState.value.sortOrderOptions
  .map((n: number) => [n, PlanktonSearchResultSortOrder[n]])
  .map((a: [n: number, option: PlanktonSearchResultSortOrder]) => {
    const option = a.at(1);
    const slug = (option === PlanktonSearchResultSortOrder.NotSet || !option) ? "maincategory" : slugged(option?.toString());
    return {
      label: t(`catalog.sort-by.${slug}`),
      value: a.at(0),
    };
  });

const sortOrder = ref((options.filter((o: any) => o.value === searchState.value.sortOrder).at(0) ?? options.at(0)));

function sort() {
  searchState.value.sortOrder = sortOrder.value.value;
}
</script>

<template>
  <div class="gap-xs flex flex-col lg:flex-row lg:items-center">
    <span class="text-nowrap text-sm text-neutral-500">{{ t("catalog.sort-by") }}</span>
    <USelectMenu v-model="sortOrder" :search-input="false" :items="options" :size="size" @update:model-value="sort" />
  </div>
</template>

<style scoped>

</style>
